module.exports = __webpack_public_path__ + "static/media/elf_on_the_slope.62907ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/elf_on_the_slope.png
// module id = 304
// module chunks = 0